module.exports = __webpack_public_path__ + "static/qrcode-box.5a0de604.png";


//////////////////
// WEBPACK FOOTER
// ./app/resource/page/index/views/images/qrcode-box.png
// module id = 1032
// module chunks = 2